import React from "react";
import { Helmet } from "react-helmet";
import { useAccount } from "../../store/account";

export default function Survey() {
    const { data: account = {} } = useAccount();
    return (
        <>
            <Helmet>
                <title>Audience Survey - Podtrac</title>
            </Helmet>
            <h1>Audience Survey</h1>
            <p>
                Understanding your audience better is important to the growth of your show, and
                that's what the Podtrac Audience Surveys are all about.
            </p>
            <p>
                These free web-based surveys for your podcast have been expertly developed and
                analyzed by the audience research professionals at Podtrac, Mediamark Inc. (MRI),
                and Taylor Nelson Sofres (TNS). TNS is the largest custom research organization in
                the world, and MRI is the country's leading provider of magazine audience and
                multimedia research data for publishers, agencies and advertisers.
            </p>
            {/*<p>More about free Podtrac Audience Surveys</p>*/}
            <h2>Put our audience survey system to work for your show(s)...</h2>
            <ol>
                <li>
                    <p>
                        <b>Add the survey link to your website.</b>
                    </p>
                    <p>Use this link for the Standard Audience Survey:</p>
                    <p>
                        <b>
                            <code>
                                http://survey.podtrac.com/start-survey.aspx?pubid={
                                    account.encryptedSurveyKey
                                }&ver=standard
                            </code>
                        </b>
                    </p>
                    <p>Use this link for the Abbreviated Audience Survey:</p>
                    <p>
                        <b>
                            <code>
                                {`http://survey.podtrac.com/start-survey.aspx?pubid=${
                                    account.encryptedSurveyKey
                                }&ver=short`}
                            </code>
                        </b>
                    </p>
                    <p>
                        Your survey link is unique to your show(s). Using it will enable us to
                        report your audience's survey responses as a distinct group.
                    </p>
                </li>
                <li>
                    <p>
                        <b>Mention the audience survey in your show(s) for at least two months.</b>
                    </p>
                    <p>
                        Talking about the survey on your shows will help drive traffic to your
                        website and the survey. And by having more listeners/viewers complete the
                        survey, you'll maximize the accuracy of your results.
                        {/*Below is some sample copy for promoting the survey on your shows.*/}
                    </p>
                </li>
                <li>
                    <p>
                        <b>Check your results online.</b>
                    </p>
                    <p>
                        Your survey results will be available in your Publisher
                        Dashboard. We recommend you check 15 days after launching the survey on your
                        site to see what type of response you are getting. Online results are
                        updated nightly.
                    </p>
                </li>
            </ol>
            <div style={{ fontSize: "0.75rem", color: "#777", marginTop: "2rem" }}>
                <p>Important Notes:</p>
                <ul>
                    <li>
                        Please contact us if you need help with any of these three steps. We'll
                        email you back with an answer or set up a time to talk.
                    </li>
                    <li>
                        The privacy of data collected about your show(s) is important to us. Podtrac
                        will not share data linked to the name or the RSS of your show(s) without
                        your permission. Podtrac may however provide summary data to third parties
                        without attributing data to your show(s) specifically. For more information,
                        please review our full Privacy Policy.
                    </li>
                    <li>
                        By providing a link to the Podtrac Survey on your website, promoting it in
                        your show(s), and/or linking to the Survey in your RSS feed, you agree to
                        our standard Terms and Conditions.
                    </li>
                </ul>
            </div>
        </>
    );
}
